import axiosInstance from "../../components/axiosInstance";

export const sendListScrapesRequest = async (data, callbackBefore = () => {}, callbackAfter = () => {}) => {
    callbackBefore();

    return await axiosInstance.get('https://marketplace-api.swierczkacper.pl/api/v1/scrapes?' + new URLSearchParams(data).toString()).then(function (response) {
        callbackAfter();

        return response;
    }).catch(function (error) {
        callbackAfter();

        return error.response;
    });
}

export const sendListScrapesPerDaysRequest = async (data, callbackBefore = () => {}, callbackAfter = () => {}) => {
    callbackBefore();

    return await axiosInstance.get('https://marketplace-api.swierczkacper.pl/api/v1/scrapes/days?' + new URLSearchParams(data).toString()).then(function (response) {
        callbackAfter();

        return response;
    }).catch(function (error) {
        callbackAfter();

        return error.response;
    });
}